import * as React from 'react'
import { Route } from 'react-router'
import { HashRouter } from 'react-router-dom'

// Common components
import ChuFormProvider from '../common/components/chu-form-provider'
import Header from '../common/components/header'
import Footer from '../common/components/footer'
import Spinner from '../common/components/spinner'
import Message from '../common/components/message'
import CurrentProgress from '../common/components/current-progress'
import FullPageContent from '../common/components/full-page-content'
import RouteContainer from '../common/components/route-container'
import DocumentHeader from '../common/components/document-header'
import '../common/common-styles.css'

// Common routes
import Payment from '../common/routes/payment'
import IndexRoute from '../common/routes/index-route'
import PaymentOffline from '../common/routes/payment-offline'
import PaymentByCard from '../common/routes/payment-by-card'
import PaymentResult from '../common/routes/payment-result'
import Restore from '../common/routes/restore'
import Declined from '../common/routes/declined'

// Project routes
import Step1 from './routes/step-1'
import Step2 from './routes/step-2'
import Step3 from './routes/step-3'
import Step4 from './routes/step-4'
import Step5 from './routes/step-5'
import Step6 from './routes/step-6'

// Project specific
import reducers from './reducer-map'
import Maintenance from "../contents/routes/maintenance";


export default class extends React.Component<any, any>{
    
    render(){
        return (
            <ChuFormProvider reducers={ reducers }>
                <div className="app">
                    <DocumentHeader icon={ require('./images/favicon.ico') }/>
                    <Spinner/>
                    <Message/>
                    <Header logo={ require("./images/logo.png") }/>
                    <HashRouter>
                        <FullPageContent>
                            <CurrentProgress/>
                            <RouteContainer>
                                <Route exact path="/" component={ IndexRoute } />
                                <Route path="/step-1" component={ Step1 } />
                                <Route path="/step-2" component={ Step2 } />
                                <Route path="/step-3" component={ Step3 } />
                                <Route path="/step-4" component={ Step4 } />
                                <Route path="/step-5" component={ Step5 } />
                                <Route path="/step-6" component={ Step6 } />
                                <Route path="/payment" component={ Payment }/>
                                <Route path="/payment-offline" component={ PaymentOffline } />
                                <Route path="/payment-by-card" component={ PaymentByCard } />
                                <Route path="/payment-result" component={ PaymentResult } />
                                <Route path="/restore" component={ Restore } />
                                <Route path="/declined" component={ Declined } />
                                <Route path="/maintenance" component={ Maintenance } />
                            </RouteContainer>
                        </FullPageContent>
                    </HashRouter>
                    <Footer/>
                </div>
            </ChuFormProvider>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/contents-root-component.tsx